import { lazy } from 'react';
export default [{ path: 'website-categories', component: lazy(() => import('views/website-categories')) }];
